
let dataInputFiles = [];

function userFiles() {

	const allowed_extensions = ['pdf', 'jpg', 'jpeg', 'png'];
	const max_mb = 12;
	const max_files = 15;
	let allow_up_file = true;
	
	let attach_button = $('[data-user-files="attach"]');
	
	$.each(attach_button, function () {
		let data = {
			identifier: $(this).attr('for')
		}

		data.attach_input = $(`#${data.identifier}`);
		
		// Array Handle FileList
		data.arrayFiles = [];
		
		// Array FileList
		data.files = data.attach_input[0].files;

		// Reset FileList on Init
		data.files = new FileListItems(data.arrayFiles);
		setFiles(data.identifier, data.arrayFiles);

		data.attach_input.on('click', function () {
			if (data.arrayFiles.length == max_files) {
				allow_up_file = false;
			}
		});
	
		// Input File Event
		data.attach_input.on('change', function () {
			
			if (allow_up_file) {

				for (let index = 0; index < this.files.length; index++) {
					let permit = true;
					
					if (data.arrayFiles.length > 0) {
						let existingFile = data.arrayFiles.find(element => element.name == this.files[index].name);

						if (existingFile == undefined) {
							permit = true;
						} else {
							permit = false;
							notify(`El archivo <strong>${this.files[index].name}</strong> ya se adjuntó`);
						}
					}

					if (validateExtension(this.files[index].name) == false) {
						notify(`Los archivos deben tener únicamente las extensiones: <strong>${allowed_extensions}</strong>`);
						permit = false;
					}

					if (validateMaxSize() == false) {
						notify(`El archivo no puede ser mayor a <strong>${max_mb} MB</strong>`);
						permit = false;
					}
					
					if (permit) data.arrayFiles.push(this.files[index]);
				}

				// Fill File in Filelist
				data.files = new FileListItems(data.arrayFiles);
				setFiles(data.identifier, data.arrayFiles);
				
				// Render HTML
				renderFiles(data.attach_input, data.arrayFiles);
				// console.log(data.files);

			} else {
				notify(`Solo puedes subir máximo <strong>${max_files} archivos</strong>`);
			}

		});
	});

	/**
	 * Render HTML List > Files
	 * @param {jQuery Selector} input 
	 * @param {array} arrayFiles 
	 */
	function renderFiles(input, arrayFiles) {
		let elementParent = input.closest('.contact__group').find('.contact__files');

		let html = ``;

		arrayFiles.forEach((file, index) => {
			html += `
				<div class="contact__files__box">
					<span class="file-name" title="${file.name}">${file.name}</span>
					<button type="button" class="file-icon-delete icon-delete" data-user-files="delete" data-user-files-id="${index}"></button>
				</div>`
				;
		});

		elementParent.html(html);
		
		renderDestroy(input, arrayFiles);
	}
	
	/**
	 * Render HTML > Destroy Buttons
	 * @param {jQuery Selector} input 
	 * @param {array} arrayFiles 
	 */
	function renderDestroy(input, arrayFiles) {
		
		let delete_buttons = $('[data-user-files="delete"]');
		
		$.each(delete_buttons, function () {
			let fileId = $(this).attr('data-user-files-id');
			
			$(this).on('click', function () {
				destroyItem(arrayFiles, fileId, input);
				
				if (arrayFiles.length < max_files) {
					allow_up_file = true;
				}
			});
		});
	}
	
	/**
	 * Destroy File in FileList
	 * @param {array} arrayFiles 
	 * @param {attr} id 
	 * @param {jQuery Selector} input 
	 */
	function destroyItem(arrayFiles, id, input) {
		let positionInit = parseInt(id);
		arrayFiles.splice(positionInit, 1);

		input[0].files = new FileListItems(arrayFiles);
		setFiles(input.attr('id'), arrayFiles);
		renderFiles(input, arrayFiles);

		// console.log(input[0].files);
	};

	function validateMaxSize(size) {
		const max_bytes = max_mb * 1048576;
		return (size > max_bytes) ? false : true;
	}

	function validateExtension(file_name) {
		let extensions = '';

		for (let index = 0; index < allowed_extensions.length; index++) {
			if (index == 0) {
				extensions += `.${allowed_extensions[index]}`;
			} else {
				extensions += `|.${allowed_extensions[index]}`;
			}
		}

		extensions = new RegExp(`(${extensions})$`, 'i');

		if(!extensions.exec(file_name) == false) {
			return true;
		} else {
			return false;
		}
	}
	
	/**
	 * @params {File[]} files Array of files to add to the FileList
	 * @return {FileList}
	 */
	function FileListItems (files) {
		var b = new ClipboardEvent("").clipboardData || new DataTransfer()
		for (var i = 0, len = files.length; i<len; i++) b.items.add(files[i])
		return b.files
	}
}

function setFiles(index, array) {
	dataInputFiles[`${index}`] = array;
}

function getFiles(index) {
	return dataInputFiles[`${index}`];
}